<template>
    <div>
        <pageHeader :showIndex="1" ref="pageHead"></pageHeader>
        <div class="main">
            <crumbs :crumbs="crumbsText"></crumbs>
            <div class="up-section up-section2">
                <div class="clearfix">
                    <div class="picBigUrl fl">
                        <img :src="courseInfo.picBigUrl">
                    </div>
                    <div class="fr course-detail">
                        <ul>
                            <li class="clearfix">
                                <h3 class="fl color3" :title="courseInfo.courseName">{{courseInfo.courseName}}</h3>
                                <!-- <div class="fr over-num">
                                    <h4>18</h4>
                                    <p>剩余名额</p>
                                </div> -->
                            </li>
                            <li class="teacher-course">
                                <label>辅导教师：</label>
                                <span class="teacher">
                                    <em class="teacher-head">
                                    <img v-if='courseInfo.teacherPic!=null' :src=" courseInfo.teacherPic" alt="老师头像">
                                    <img v-else src="../../assets/images/pic.png">
                                    </em>
                                    <em class="color3">{{courseInfo.teacherName}}</em>
                                </span>
                            </li>
                            <li class="clearfix">
                                <div class="fl">
                                    <label>课程有效期：</label>
                                    <span class="color6"><em>{{courseInfo.courseValidity}}天</em></span>
                                </div>
                                <div class="fr" style="margin-right:30px;">
                                    <div class="collect"  @click="courseCollect()">
                                    <!-- isCollect  0  1  -->
                                    <!-- <i class="iconfont" v-if="courseDetailData.isCollect == 0">&#xe605;</i> -->
                                    <!-- <i class="iconfont" style="color:#ff6060;" v-else>&#xe605;</i> -->
                                    <i class="iconfont" v-if="hasCollection">&#xe605;</i>
                                    <i class="iconfont" style="color:#ff6060" v-else>&#xe605;</i>

                                    <!-- <i class="iconfont" v-if="collectIcon == 0" @click="collectCourse(courseDetailData.id)" >&#xe605;</i> -->
                                        <!-- <i class="iconfont" v-else style="color:#ff6060"  @click="collectCourse(courseDetailData.id)">&#xe600;</i> -->
                                    <em class="color6">收藏课程</em>
                                    </div>
                                </div>
                            
                            </li>
                            <li class="clearfix">

                                <div class="fr" style="margin-right:30px;">
                                    <label>购买用户:</label>
                                    <span class="color6"> <em>{{courseInfo.numByStudent}}</em> 人</span>
                                    
                                </div>
                            </li>
                            <li class="clearfix">
                                <span class="price fl">
                                    <label>当前价格：</label>
                                    <em>￥{{courseInfo.realPrice}}</em>
                                    <!-- <em>￥{{courseDetailData.originalPrice}}</em> -->
                                </span>
                                <!-- <a href="javascript:void(0);" class="apply-btn fr" @click="toPay()">立即报名</a> -->
                                <a v-if="courseInfo.isBuy == 0" href="javascript:void(0);" class="apply-btn fr" @click="toPay()">立即报名</a>
                                <a v-else href="javascript:void(0);" class="apply-btn disable fr">已报名</a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="down-section clearfix">
                <!--左侧-->
                <div class="left-section fl">
                    <div class="tabs">
                    <ul class="clearfix">
                        <li v-for="(tab,index) in tabBars" :class="{active:tab.isSelect}" :key="index" @click="changeTabWithIndex(index)">{{tab.name}}</li>
                    </ul>
                    </div>
                    <div v-if="showTab == 0">
                        <div v-html="courseInfo.courseIntroduction" class="courseIntroduction"></div>
                    </div>
                    <!--课程大纲-->
                    <div v-else-if="showTab == 1" >
                        <el-collapse  @change="handleChange">
                            <el-collapse-item v-for="(courseChapter,index) in courseInfo.courseChapters" :key="index" :title="courseChapter.chapterName" :name="index">
                                <div class="section-cont">
                                <ul>
                                    <li v-for="(courseLecture,lectureIndex) in courseChapter.courseLectures" :key="courseLecture.id">
                                        <el-row>
                                            <el-col :span="1">{{lectureIndex+1}}.</el-col>
                                            <el-col :span="12">{{courseLecture.lectureName}}</el-col>
                                            <el-col :span="2">
                                                <span class="color-red" v-if="courseLecture.isAudition==1">*试听课*</span>

                                            </el-col>
                                            <el-col :span="9" v-if="courseLecture.isAudition==1 || courseInfo.isBuy==1">
                                                <a href="javascript:void(0);" @click="gotoPlayCourse(courseChapter.id,courseLecture.id)">
                                                    进入学习
                                                </a>
                                            </el-col>
                                            <el-col :span="9" v-else>
                                                
                                            </el-col>
                                        </el-row>

                                       
                                    </li>
                                </ul>
                                </div>
                            </el-collapse-item>
                        </el-collapse>

                    </div>
                    <!--课程评价-->
                    <div v-else class="section-cont">
                        <div class="tabs-content student-evaluate">
                            <div style="margin-top:10px;" v-if="courseInfo.isComment == false">
                                <div class="pin-box clearfix">
                                    <div class="fl">
                                        <label class="fl" style="display:inline-block;">星级评价：</label>
                                        <el-rate class="fl" v-model="value1"></el-rate>
                                    </div>
                                    <div class="fr">
                                        {{courseInfo.totalCommentCount}}人参与评价
                                    </div>
                                
                                </div>
                                <div class="evaluate-btn" style="margin-top:10px;"><a href="javascript:void(0);" @click="addComment">评价</a></div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                <!--右侧-->
                <div class="right-section fr">
                    <div class="need clearfix color6">
                        <div class="fl">猜你喜欢</div>
                        <a href="javascript:void(0);" class="fr iconfont change" @click="getYouLike()">&#xe636;</a>
                    </div>
                    <div class="like-course">
                        <ul>
                            <li v-for="(recommenCourse,index) in recommendCourses" :key="index" @click="showCourse(recommenCourse)">
                                <div class="course-img">
                                    <img :src="recommenCourse.picBigUrl">
                                </div>
                                <h3>{{recommenCourse.courseName}}</h3>
                                <div class="clearfix">
                                    <div class="fr color-red">
                                        <em v-if="recommenCourse.realPrice == 0 || recommenCourse.realPrice == 0">免费</em>
                                        <em v-else>￥{{recommenCourse.realPrice}}</em>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
        <pageFooter></pageFooter>
    </div>
</template>
<script>
import pageHeader from '../header/header'
import pageFooter from "../footer/pageFooter"
import Crumbs from '../crumbs/crumbs'
export default {
    name: 'app',
    components: {
        pageHeader,
        pageFooter,
        Crumbs
    },
    data(){
        return{
            crumbsText:[ //面包屑导航
                {name:'课程',path:'/courseList'},
                {name:'课程详情',path:''},
            ],
            courseInfo:{},  //课程信息
            recommendCourses:[], //推荐课程
            hasCollection: false,
            showTab:1,
            tabBars:[
                {name:'课程简介',isSelect:false},
                {name:'课程大纲',isSelect:true},
                {name:'课程评价',isSelect:false}
            ],
            value1: null
        }
    },
    created(){
        // console.log(this.$route.params.courseId)
        this.getCourseData();
        this.getYouLike();
    
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'getCourseData'
    },
    methods:{
        handleChange(val) {
            console.log(val);
        },
        // tab筛选切换(本地操作)
        changeTabWithIndex(index){
            for(let i = 0;i<3;i++){
                let tab = this.tabBars[i]
                if(i == index){
                    tab.isSelect = true
                }else{
                    tab.isSelect = false
                }
                this.showTab = index
            }
        },
        //获取课程详情数据 userId courseId (created()内调用)
        getCourseData(){
            var userId = ''
            if(localStorage.userId){
                userId = localStorage.userId
            }else{
                userId = '0'
            }

            let apiUrl = this.baseUrl()+'/mobile/tbCourse/courseDetail/'+ this.$route.params.courseId+'/'+userId;

            this.$http.post(apiUrl,{}).then(function(res){
				
                this.courseInfo = res.data.data;
                
                this.hasCollection = this.courseInfo.isCollect
				console.log(res.data.data);

			}).catch(function (error) {
				console.log(error);
			});
            
        },
        //进入学习课程
        gotoPlayCourse(chapterId,lectureId){
            console.log("调用参数："+chapterId);
            this.$router.push({name:'coursePlay',params:{courseId:this.courseInfo.id,chapterId:chapterId,lectureId:lectureId}});

        },
        //去支付(立即报名)接口
        toPay(){
            if(!localStorage.userId){
                this.$alert('登录后购买',{
                    callback:() =>{
                        //直接弹出登录框
                        this.$refs.pageHead.loginViewShow()
                    }
                })
                return
            }
            
            let postData = {
                commodityName:this.courseInfo.courseName,
                commodityId:this.courseInfo.commodityId,
                remark:'Commit AndCreatedOrderNumber',
                userId:localStorage.userId,
                token: localStorage.token
            }
            
            this.$http.post(this.baseUrl()+'/mobile/payOrder/add',
                    this.$qs.stringify(postData),
                    {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                if(successResp.data.flag == 1){
                    //免费课程去支付
                    if(this.courseInfo.realPrice == null || this.courseInfo.realPrice == 0){
                        this.getCourseData()
                        this.$alert('报名成功')
                    }else{
                        let orderId = successResp.data.data;

                        this.fullscreenLoading = false
                        //去支付界面
                         this.$router.push('/payview/'+ orderId)
                    } 
                    
                }

            })    
        },
        //课程收藏&取消收藏(接口)
        courseCollect(){
            if(!localStorage.userId){
                this.$alert('登录后可收藏',{
                callback: ()=>{
                        //直接弹出登录框
                        this.$refs.heade.loginViewShow()
                    }
                })
                return
            }

            let apiUrl = this.baseUrl()+'/mobile/tbCourse/collectCourse/'+this.courseInfo.id +'/'+ localStorage.userId;

            this.$http.post(apiUrl,
                    '',
                    {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                if(successResp.data.flag == 1){
                   if(this.hasCollection){
                        this.hasCollection = false
                        this.collectNum--
                    }else{
                        this.hasCollection = true
                        this.collectNum++  
                    }
                    
                }

            })  
        },
        //用户评价
        addComment(){
            if(this.courseInfo.isBuy == 0){
            
                this.$alert("您还没有购买该课程")
                return;
            }
            if(!localStorage.userId){
                this.$alert('您还没有登录',{
                    callback:() =>{
                    //直接弹出登录框
                    this.$refs.heade.loginViewShow()
                    }
                })
                return
            }
            if(this.value1 == 0){
                this.$alert('您还没有评价星级')
                return
            }
            
            let apiUrl = this.baseUrl()+'/mobile/tbCourse/saveComment';
            let postData = {
                courseId: this.courseInfo.id,
                starsNum:this.value1,
                userId: localStorage.userId,
                token: localStorage.token
            }

            this.$http.post(apiUrl,
                    this.$qs.stringify(postData),
                    {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                if(successResp.data.flag == 1){
                    
                    this.$alert('添加评论成功', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            this.courseInfo.isComment = true
                            
                        }
                    });
                   
                }

            })  
        
        },
        //获取猜你喜欢课程
        getYouLike(){

            let apiUrl = this.baseUrl()+'/mobile/tbCourse/getCourseByTypeRandom';
            let postData = {
                courseType:this.courseInfo.courseType
            }

            this.$http.post(apiUrl,
                    this.$qs.stringify(postData),
                    {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                if(successResp.data.flag == 1){
                    this.recommendCourses = successResp.data.data
                }

            })   
        },
        showCourse(recommenCourse){
            this.$router.push({name:'courseInfo',params:{courseId:recommenCourse.id}})
        }
    }
}
</script>
<style scoped>
    /*上面*/
    .up-section{
        width: 1200px;
        margin: 0 auto 22px;
        background: #fff;
        box-sizing: border-box;
        color: #999;
    }

    .color3{
    color: #333;
    }
    .color6{
    color: #666;
    }
    .color9{
    color: #999;
    }
    .color-red{
        color: #ff6060;
    }
    .up-section .course-img{
        overflow: hidden;
    }
    .up-section1 .course-img{
        width: 320px;
        /*height: 192px;*/
        margin-right: 30px;
    }
    .up-section .course-img.p20{
        padding:20px 0 20px 20px;
    }
    .up-section1 .course-img img{
    width: 100%;
    max-width: 100%;
    }
    .up-section2 .course-img{
    width: 776px;
    height: 436px;
    }
    .up-section2 .course-img img{
    width: 100%;
    max-width: 100%;
    }
    .up-section1 .course-detail{
    padding-top: 20px;
    width: 830px;
    height: 256px;
    /*height: 232px;*/
    box-sizing: border-box;
    position: relative;
    }
    .up-section2 .course-detail{
    width: 410px;
    height: 436px;
    box-sizing: border-box;
    position: relative;
    padding-top: 20px;
    position:relative;
    }
    .up-section2 .course-detail ul li{
    margin-bottom: 37px;
    }
    .up-section2 .course-detail ul li:last-child{
    position: absolute;
    width: 100%;
    bottom:0;
    margin-bottom: 0;
    }
    .up-section .course-img img{
    min-height: 100%;
    min-width: 100%
    }
    .up-section h3,.up-section h4{
    font-weight: bold;
    }
    .up-section h3{
    font-size: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    }
    .up-section1 h3{
    margin-right: 40px;
    max-width: 450px;
    }
    .up-section2 h3{
    margin-right: 40px;
    max-width: 280px;
    }
    .apply-btn{
    display: inline-block;
    width: 232px;
    height: 56px;
    line-height: 56px;
    background: #ff6060;
    color: #fff;
    font-size: 18px;
    text-align: center;
    margin-left: 40px;
    }
    .apply-btn.disable{
    background-color: #d4d4d4;
    cursor: default;
    }
    .collect .iconfont{
    font-size: 28px;
    margin-right: 10px;
    vertical-align: middle;
    }
    .collect{
    position: relative;
    top:-4px;
    }
    .collect em{
    line-height: 34px;
    display: inline-block;
    vertical-align: middle;
    }
    .over-num{
    padding-right: 20px;
    text-align: center;
    color: #ff6060;
    position: relative;
    top: -4px;
    }
    .over-num h4{
    font-size: 16px;
    }
    .teacher-course{
    margin-top: 5px;
    }
    .teacher-course .teacher{
    margin-right: 100px;
    }
    .teacher-head{
    display: inline-block;
    width: 54px;
    height: 54px;
    overflow: hidden;
    border-radius: 54px;
    vertical-align: middle;
    margin-right: 15px;
    }
    .teacher-head img{
    min-height: 100%;
    min-width: 100%;
    width: 100%;
    } 
    /*----------------------------*/
    .service-item{
    width: 100%;
    margin-top: 10px;
    }
    .service-item .label{
    line-height: 30px;
    vertical-align: middle;
    margin-right: 5px;
    }
    .service-item .more-btn{
    margin-right: 10px;
    vertical-align: middle;
    cursor: pointer;
    }
/*.service-item span.course-sevice{
  width: 90%;
  display: inline-block;
  overflow-x: hidden;
}
.service-item span.more{
  width: 8%;
  display: inline-block;
  float: right;
}*/
/**/
    .service-item .course-sevice{
    width: 80%;
    height: 36px;
    overflow-y: hidden;
    }
    .course-sevice em{
    display: inline-block;
    height: 34px;
    line-height: 34px;
    padding: 0 10px;
    background: #f7f7f7;
    border-radius: 4px;
    color: #666;
    margin-right: 10px;
    margin-bottom: 0.5rem;
    }
    .course-sevice em:last-child{
    margin-right: 0;
    }
    .time-price{
    width: 100%;
    line-height: 56px;
    /*position: relative;
    bottom: 0;*/
    position: absolute;
    bottom: 0;
    }
    .price{
    line-height: 56px; 
    }
    .price em{
    color: #ff6060;
    font-size: 18px;
    }

    /*下面部分*/
    .down-section{
        width: 1200px;
        margin: 0 auto;
    }
    .left-section{
        width: 820px;
        min-height: 600px;
        background: #fff;
    }
    .right-section{
        width: 360px;
    }
    .tabs{
        padding-left: 20px;
    }
    .tabs ul li{
        float: left;
        height: 60px;
        line-height: 60px;
        padding: 0 30px;
        cursor: pointer;
    }
    .tabs ul li.active{
        background: #f49d40;
        color: #fff;
    }
    .section-cont h3{
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        color: #333;
        font-weight: bold;
        background: #eeeeee;
    }
    .section-cont h3 .iconfont{
    color: #999;
    cursor: pointer;
    }
    .section-cont ul{
    padding: 15px 0px;
    }
    .section-cont ul li{
    padding: 10px 20px 10px 80px; 
    color: #666;
    line-height: 30px;
    cursor: pointer;
    }
    .section-cont ul li:hover{
    color: #f49d40;
    }
    .section-cont ul li.active span.course-name{
    position: relative;
    color: #f49d40;
    }
    .section-cont ul li.active span.course-name:before{
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-left: 12px solid #f49d40;
    border-bottom: 8px solid transparent;
    position: absolute;
    left: -30px;
    top:5px;
    }
    .section-cont ul li:hover span.course-name:before{
    border-left-color: #f49d40;
    }
    /*课程评价*/
    .check-appraise ul{
        float: left;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        border:1px solid #ff6060;
        }
    /*右侧猜您喜欢*/
    .need{
    height: 60px;
    background: #fff;
    box-sizing: border-box;
    padding: 20px;
    margin-bottom: 15px;
    }
    .like-course ul li{
    padding: 20px;
    border-bottom: 1px solid #dfdfdf;
    background: #fff;
    color: #666;
    }
    .like-course ul li:last-child{
    border-bottom: 0;
    }
    .like-course .course-img{
        width: 310px;
        height: 184px;
        border-radius: 10px;
        overflow: hidden;
    }
    .like-course .course-img img{
        width: 100%;
        max-width: 100%;
        max-height:184px;
    }
    .like-course h3{
        font-weight: bold;
        margin: 10px 0;
        color: #2c3e50;
    }
    /*课程介绍*/
    .courseIntroduction{
        padding: 10px 20px;
        line-height: 25px;
    }
    /*课程评价*/
    .commentView{
        padding: 5px 30px;
    }
    .evaluate-btn a{
        background: #00ced1;
        color: #fff;
        width: 50px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        display: inline-block;
        border-radius: 4px;
    }
    .picBigUrl{
    width: 725px;
    /*height: 300px;*/
    height: 436px;
    overflow: hidden;
    }
    .picBigUrl img{
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    }
</style>